import { render, staticRenderFns } from "./AsDownloads.vue?vue&type=template&id=56cbe2e2&scoped=true&"
import script from "./AsDownloads.vue?vue&type=script&lang=js&"
export * from "./AsDownloads.vue?vue&type=script&lang=js&"
import style0 from "./AsDownloads.vue?vue&type=style&index=0&id=56cbe2e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cbe2e2",
  null
  
)

export default component.exports